import * as React from "react";
import Header from "../components/navigation/Header";
import FalconFooter from "../components/navigation/FalconFooter";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    productHelper,
    ProductsEnum,
    Quote,
    resourcesHelper,
    Types
} from "@falcon/services";
import {Link} from "react-router-dom";
import {lazyInject} from "@athena-portal/core";
import {PluginTemplates} from "../utils/PluginTemplates";

interface IState {
    link: string,
    annualMotorQuotes: Quote[];
    annualHomeQuotes: Quote[];
}

export class ProductSelectionPage extends React.Component<{}, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;
    private readonly MOTOR_QUOTES_PAGE: string = "/dashboard/annualQuotes";
    private readonly HOME_QUOTES_PAGE: string = "/dashboard/HomeInsuranceQuotes";

    constructor(props: any) {
        super(props);
        this.state = {
            annualMotorQuotes: [],
            annualHomeQuotes: [],
            link: ""
        };
        document.title = `${resourcesHelper.THEME} products page`;
    }

    public render(): React.ReactNode {
        return (
            <div id="root">
                <Header/>
                <div className="page-contents page-contents-title-format">
                    <FalconNavigatorHeader back="/dashboard"/>
                    <h1 className="text-white text-center product-selection-title">What kind of insurance do you
                        need?</h1>
                    {this.renderRadios()}
                </div>
                <FalconFooter/>
            </div>
        );
    }

    public componentDidMount() {
        this.fetchQuotes();
    }

    private fetchQuotes = () => {
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => {
            this.setState({
                annualMotorQuotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR),
                annualHomeQuotes: this.getQuotesByProduct(quotes, ProductsEnum.HOME)
            });
        });
    };

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }

    private renderRadios = (): JSX.Element => {
        const annualMotorEnabled: boolean = process.env.REACT_APP_ANNUAL_MOTOR_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_MOTOR_ENABLED) : true;
        const annualHomeEnabled: boolean = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : false;
        const rentersProductEnabled: boolean = process.env.REACT_APP_RENTERS_PRODUCT_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_PRODUCT_ENABLED) : false;
        const subscriptionMotorProductEnabled: boolean = process.env.REACT_APP_MOTOR_PRODUCT_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_PRODUCT_ENABLED) : false;
        return (
            <>
                <div className="product-context-form">
                    {annualMotorEnabled && this.renderAnnualMotorTile(annualHomeEnabled)}
                    {annualHomeEnabled && this.renderAnnualHomeTile()}
                    {subscriptionMotorProductEnabled &&
                        <div className="product-section desktop-w-50 section-bottom-indent">
                            <div className="section-panel h-100 section-indent">
                                <div className="section overflow-hidden text-center">
                                    <div className="fixed-height-tile">
                                        <img className="product-section-img"
                                             src={`/${resourcesHelper.THEME}/img/wolf-car-icon.png`} alt="car icon"/>
                                        <div className="product-title">Monthly car insurance</div>
                                    </div>
                                    <p className="product-description">
                                        No deposit, no fees, no interest to pay and no surprises. Just rolling monthly
                                        car
                                        insurance for as long as you need. Perfect.
                                    </p>
                                    <div className="get-quote-button d-flex justify-content-center">
                                        <Link
                                            to={this.getPageLink(ProductsEnum.MOTOR)}
                                            className="inner-content buttonLink"
                                            id="motor-product-link">
                                            <button id="mscar-btn" type="button" className="btn btn-primary btn-add">
                                                Monthly car quote
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    {rentersProductEnabled && <div className="product-section desktop-w-50 section-bottom-indent">
                        <div className="section-panel h-100 section-indent">
                            <div className="section overflow-hidden text-center">
                                <div className="fixed-height-tile">
                                    <img className="product-section-img" src="/img/renters-cover-icon.png"
                                         alt="renter icon"/>
                                    <div className="product-title">Renters <br/>Insurance</div>
                                </div>
                                <p className="product-description">
                                    Cover your belongings your way and change it up free of charge with flexible,
                                    rolling
                                    monthly contents insurance just for renters.
                                </p>
                                <div className="get-quote-button d-flex justify-content-center">
                                    <Link
                                        to={this.getPageLink(ProductsEnum.SUBSCRIPTION)}
                                        className="inner-content buttonLink"
                                        id="renters-product-link">
                                        <button id="renter-btn" type="button" className="btn btn-primary btn-add">
                                            Renters quote
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                {this.renderRenewalDateCapturePanel()}
            </>
        );
    };

    private renderAnnualMotorTile = (annualHomeEnabled: boolean) => {
        const carInsuranceTitle = resourcesHelper.THEME === "Allianz" ? "Comprehensive car insurance" : "Annual car insurance";
        const annualMotorQuoteCount: number = this.state.annualMotorQuotes.length;
        const hasMotorQuotes: boolean = annualMotorQuoteCount > 0;
        const linkToNbJourney = `${this.getPageLink(ProductsEnum.WOLF_MOTOR)}`;
        return (
            <div
                className={`product-section  ${annualHomeEnabled ? "desktop-w-50" : "desktop-w-100"} section-bottom-indent`}>
                <div className="section-annual-panel">
                    {this.renderQuoteCountWording(annualMotorQuoteCount)}
                    <div className="overflow-hidden text-center">
                        <div className="d-flex">
                            <div className="d-flex col-sm-4"/>
                            <div className="product-section-logo d-flex align-self-end col-sm-4">
                                <img className="product-section-img m-auto"
                                     src={`/${resourcesHelper.THEME}/img/wolf-car-icon.png`}
                                     alt="car icon" id="car-logo"/>
                            </div>
                            <div className="product-section-defaqto-logo d-flex col-sm-4 ">
                                <img className="defaqto-logo-sm" src="/img/DefaqtoLogo.svg"
                                     alt="Defaqto logo" aria-label="Defaqto logo"/>
                            </div>
                        </div>
                        <div className="annual-section">
                            <div className="product-title">{carInsuranceTitle}</div>
                            {PluginTemplates.getNewQuoteWording[ProductsEnum.WOLF_MOTOR]}
                            <Link
                                to={hasMotorQuotes ? this.MOTOR_QUOTES_PAGE : linkToNbJourney}
                                className="inner-content buttonLink"
                                id="viewSavedSubscriptionCarQuotes">
                                <button type="button" className="btn btn-primary btn-add">
                                    {hasMotorQuotes ? "View your car quote" : "Car quote"}
                                </button>
                            </Link>
                            <div className="quote-panel-view-quotes mt-3">
                                {
                                    hasMotorQuotes
                                        ? <Link className="text-decoration-underline muli-bold-16" to={linkToNbJourney}>
                                            Get a new car quote </Link>
                                        : <p className="mb-0">
                                            You don't have any car quotes
                                        </p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    private renderAnnualHomeTile = () => {
        const annualHomeQuoteCount: number = this.state.annualHomeQuotes.length;
        const hasHomeQuotes: boolean = annualHomeQuoteCount > 0;
        const linkToNbJourney = `${productHelper.getNewBusinessUrl(ProductsEnum.HOME)}/dashboardEntryPage`;
        return (
            <div className="product-section desktop-w-50 section-bottom-indent">
                <div className="section-annual-panel">
                    {this.renderQuoteCountWording(annualHomeQuoteCount)}
                    <div className="overflow-hidden text-center">
                        <div className="d-flex">
                            <div className="d-flex col-sm-4"/>
                            <div className="product-section-logo d-flex align-self-end col-sm-4">
                                <img className="product-section-img m-auto" src="/img/home-icon.png"
                                     alt="home icon"
                                     id="home-logo"/>
                            </div>
                            <div className="product-section-defaqto-logo d-flex col-sm-4 ">
                                <img className="defaqto-logo-sm" src="/img/DefaqtoLogoHome.svg"
                                     alt="Home Defaqto logo" aria-label="Defaqto logo home"/>
                            </div>
                        </div>
                        <div className="annual-section">
                            <div className="product-title">Buildings and contents home insurance</div>
                            {PluginTemplates.getNewQuoteWording[ProductsEnum.HOME]}
                            <Link
                                to={hasHomeQuotes ? this.HOME_QUOTES_PAGE : linkToNbJourney}
                                className="inner-content buttonLink"
                                id="viewSavedSubscriptionHomeQuotes">
                                <button type="button" className="btn btn-primary btn-add">
                                    {hasHomeQuotes ? "View your home quote" : "Home quote"}
                                </button>
                            </Link>
                            <div className="quote-panel-view-quotes mt-3">
                                {
                                    hasHomeQuotes
                                        ? <Link className="text-decoration-underline muli-bold-16" to={linkToNbJourney}>
                                            Get a new home quote
                                        </Link>
                                        : <p className="mb-0">You don’t have any home quotes</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderQuoteCountWording = (quoteCount: number) => {
        const quoteText: string = quoteCount === 1 ? " quote" : " quotes";
        return (
            <div className="valid-quote-counter">
                <p>You have <span className="muli-bold-16">{quoteCount}</span> {quoteText}</p>
            </div>
        );
    }

    private renderRenewalDateCapturePanel = () => {
        return (
            <div className="banner banner-content">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <span className="font-weight-bold">Not the right time for a quote?</span>
                    <p className="mt-3">If you have a policy with another insurer, just let us know when it's due for
                        renewal.</p>
                    <p className="mt-3">We'll get in touch before your renewal date so you can get a quote from us and
                        compare it with
                        your current provider.{' '}
                        <a href={"https://cloud.comms.allianz.co.uk/RenewalDateCapture"} id="renewal-date-capture-link">Let
                            us know</a>
                    </p>
                </div>
            </div>
        )
    }

    private getPageLink(product: ProductsEnum) {
        const fromDashboard: boolean = window.sessionStorage.getItem("fromDashboard") === "true";
        if (product === ProductsEnum.WOLF_MOTOR) {
            return fromDashboard ?
                productHelper.getNewBusinessFromDashboardUrl(ProductsEnum.WOLF_MOTOR) :
                productHelper.getNewBusinessUrl(ProductsEnum.WOLF_MOTOR);
        } else if (product === ProductsEnum.MOTOR) {
            return productHelper.getNewBusinessUrl(ProductsEnum.MOTOR);
        } else if (product === ProductsEnum.HOME) {
            return fromDashboard ?
                productHelper.getNewBusinessFromDashboardUrl(ProductsEnum.HOME) :
                productHelper.getNewBusinessUrl(ProductsEnum.HOME);
        } else {
            return productHelper.getNewBusinessUrl(ProductsEnum.RENTERS);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/ProductSelectionPage.tsx